// import { appId } from "@/api/cg/service/helper";
import http from "../base";
import {
  INS_API_LOGIN,
  INS_API_FXCAL_GET_SSO_ACCOUNTS,
  INS_API_FXCAL_SSO_LOGIN
} from "../constants/event_consts";
import {
  INS_LGOIN,
  FIXCAL_SSO_ACCOUNT,
  FIXCAL_SSO_LOGIN
} from "../constants/path";
import PresisiteAPIParams from "../persisits/lunch_params";
import { cg_api_signed_body, creatUUid } from "../utils/index";
import encryptPassword from "encryption_pwd";
import { handleIgHeaders } from "../utils";
import { mobileconfig } from "@/api/ins_api_new/apis/ins_lunch";

export async function ins_login(
  username: string,
  password: string
): Promise<void> {
  try {
    const body: Record<string, any> = {};
    body.username = username;
    const enc_password = encryptPassword(
      password,
      await PresisiteAPIParams.getPubKey(),
      await PresisiteAPIParams.getKeyId()
    );
    body.enc_password = enc_password;
    body.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");
    body.phone_id = await PresisiteAPIParams.getAPIId(
      "cg_api_family_device_id"
    );
    body.adid = await PresisiteAPIParams.getAPIId("cg_api_ad_id");
    body.att_permission_status = "0";
    body.has_seen_aart_on = "1";
    body.login_attempt_count = "0";
    body.reg_login = "0";
    const { data, headers } = await http.post(
      INS_LGOIN,
      { data: cg_api_signed_body(body) },
      {
        return_headers: true
      },
      INS_API_LOGIN
    );
    console.log("inslogin api", data);
    const userId = data && data.logged_in_user && data.logged_in_user.pk;
    if (userId) {
      handleIgHeaders(headers, userId);
      await mobileconfig(userId);
    }
    console.log("login result", data);
    return data;
  } catch (error) {
    console.log("login error", error);
    return Promise.reject(error);
  }
}

export const fxcalSsoAccount = async (token: string) => {
  const getBody: Record<string, any> = {};
  const getToken: Record<string, any> = {};
  getToken.token_source = "active_account";
  getToken.token_id = "0";
  getToken.account_type = "Facebook";
  getToken.token_str = token;
  getToken.token_type = "web";
  getBody.tokens = [getToken];
  getBody.surface = "login";
  getBody.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  getBody.include_social_context = "0";

  const result = await http.post(
    FIXCAL_SSO_ACCOUNT,
    {
      data: cg_api_signed_body(getBody)
    },
    {},
    INS_API_FXCAL_GET_SSO_ACCOUNTS
  );
  console.log("fxcalSsoLogin result", result);
  return result.result;
};

export const fxcalSsoLogin = async (result: any, token: string) => {
  try {
    const item = result[0];
    const connectedAccounts = item.connected_accounts;
    const connectedAccount = connectedAccounts[0];
    const user = connectedAccount.user;
    const pk = user.pk;
    const loginBody: Record<string, any> = {};
    loginBody.pk = String(pk);
    loginBody.surface = "login_continue_button";
    loginBody.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");
    const loginToken: Record<string, any> = {};
    loginToken.token_source = "active_account";
    loginToken.token_id = "0";
    loginToken.account_type = "Facebook";
    loginToken.token_str = token;
    loginToken.token_type = "web";
    loginBody.token = loginToken;
    loginBody.waterfall_id = creatUUid()
      .replace("_", "")
      .toLowerCase();

    const { data, headers } = await http.post(
      FIXCAL_SSO_LOGIN,
      { data: cg_api_signed_body(loginBody) },
      { return_headers: true },
      INS_API_FXCAL_SSO_LOGIN
    );

    const userId = data && data.logged_in_user && data.logged_in_user.pk;
    if (userId) {
      handleIgHeaders(headers, userId);
      await mobileconfig(userId);
    }
    console.log("login result", data);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
